<template>
  <v-card class="edit-coupon-group" height="90vh">
    <v-card-title>{{ $t('admin_acc_coupon_group.edit_title') }}</v-card-title>
    <v-card-text>
      <div class="fill-height d-flex flex-column" v-if="couponGroup">
        <v-row class="flex-grow-0">
          <v-col>
            <v-text-field readonly
                          hide-details
                          :label="$t('admin_acc_coupon_group.name')"
                          :value="couponGroup.name"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="flex-grow-0" no-gutters>
          <v-col class="text-right">
            <v-btn color="primary"
                   class="ml-2"
                   :disabled="selectedCouponIds.length === 0"
                   @click="editCoupons">
              {{ $t('edit') }}
              {{ selectedCouponIds.length > 0 ? `(${selectedCouponIds.length})` : '' }}
            </v-btn>
            <v-btn color="primary"
                   class="ml-2"
                   :disabled="selectedCouponIds.length === 0"
                   @click="deleteCoupons">
              {{ $t('delete') }}
              {{ selectedCouponIds.length > 0 ? `(${selectedCouponIds.length})` : '' }}
            </v-btn>
            <v-btn color="primary"
                   class="ml-2"
                   :disabled="selectedCouponIds.length === 0"
                   @click="assignCoupons">
              {{ $t('admin_acc_coupon_group.assign_title') }}
              {{ selectedCouponIds.length > 0 ? `(${selectedCouponIds.length})` : '' }}
            </v-btn>
            <v-btn color="primary"
                   class="ml-2"
                   @click="createCoupon">
              {{ $t('admin_acc_coupon_group.add_coupon_title') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="flex-grow-1">
          <v-col>
            <AdminCouponList full-height
                             :extra-filters="{'group.id': [couponGroupId]}"
                             :refresh-trigger.sync="couponRefreshTrigger"
                             show-select
                             v-model="selectedCouponIds"></AdminCouponList>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit')">
        {{ $t('close') }}
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>
<script>
import {onMounted, ref} from "@vue/composition-api";
import AdminCouponList from "@/components/acc_booking/AdminCouponList.vue";
import CreateCouponModal from "@/components/acc_booking/coupon/CreateCouponModal.vue";
import AssignCouponModal from "@/components/acc_booking/coupon/AssignCouponModal.vue";
import EditCouponValidUntilModal from "@/components/acc_booking/coupon/EditCouponValidUntilModal.vue";

export default {
  name: 'EditCouponGroupModal',
  components: {AdminCouponList},
  props: {
    couponGroupId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const couponGroup = ref(null);
    const couponRefreshTrigger = ref(false);

    const getCouponGroup = function () {
      root.$callAPI('aafb/admin/coupon_group/', {
        coupon_group_id: props.couponGroupId,
      }, (response) => {
        couponGroup.value = response.body.group;
      });
    }

    const createCoupon = async function () {
      const needRefresh = await root.$dialog.showAndWait(CreateCouponModal, {
        couponGroupId: props.couponGroupId,
        showClose: false,
        persistent: true,
        width: '60vw',
      });

      if (needRefresh) {
        couponRefreshTrigger.value = true;
      }
    }

    const assignCoupons = async function () {
      const needRefresh = await root.$dialog.showAndWait(AssignCouponModal, {
        couponIds: selectedCouponIds.value,
        showClose: false,
        persistent: true,
        width: '60vw',
      });

      if (needRefresh) {
        couponRefreshTrigger.value = true;
      }
    }

    const editCoupons = async function () {
      const needRefresh = await root.$dialog.showAndWait(EditCouponValidUntilModal, {
        couponIds: selectedCouponIds.value,
        showClose: false,
        persistent: true,
        width: '60vw',
      });

      if (needRefresh) {
        couponRefreshTrigger.value = true;
      }
    }

    const deleteCoupons = function () {
      if (confirm('Confirm Delete Un-used Vouchers?')) {
        root.$callAPI('aafb/admin/coupon_group/delete_coupons/', {
          coupon_group_id: props.couponGroupId,
          coupon_ids: selectedCouponIds.value,
        }, function (response) {
          couponRefreshTrigger.value = true;
        })
      }
    }

    const selectedCouponIds = ref([]);

    onMounted(() => {
      getCouponGroup();
    })

    return {
      requiredRules,
      couponGroup,
      couponRefreshTrigger,
      createCoupon,
      assignCoupons,
      editCoupons,
      deleteCoupons,

      selectedCouponIds,
    }
  }
}
</script>

<style lang="less">
.edit-coupon-group {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .v-window__container {
    height: 100%;

    .v-window-item {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }

  .v-card__title, .v-card__text, .v-card__actions {
    width: 100%;
  }

  .v-card__title, .v-card__actions {
    flex: 0 0 auto;
  }

  .v-card__text {
    flex: 1 1 0;
    overflow: auto;
  }
}


</style>
